import { optionField } from '@/common/utils/form/fieldTypes';

export const itinerary_edit_scheduled_ports_onboard = 'itinerary_edit_scheduled_ports_onboard';

export type ItineraryEditScheduledPortsOnboard =
  | {
      label: string;
      value: string;
    }
  | number
  | null;

export type ItineraryOnboardType = {
  [itinerary_edit_scheduled_ports_onboard]: ItineraryEditScheduledPortsOnboard;
};

const config = {
  [itinerary_edit_scheduled_ports_onboard]: optionField()
};

export default config;
